import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridUserGroupRolesSettings {

  constructor(private translate: TranslateService) { }

  public agGridUserGroupRolesSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 35,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      {
        field: 'userName',
        headerName: `${this.translate.data["GROUPROLEUSERSCOLUMNHEADER"]}`,
        sortable: false,
        filter: false,
        minWidth: 266,
        // maxWidth: 316
        cellStyle: (params: any) => {
          return { color: params?.data?.isNew ? 'red' : '#303f6f' };
        }
            },
            {
        field: 'email',
        headerName: `${this.translate.data["USERSEMAILCOLUMNHEADER"]}`,
        cellStyle: (params: any) => {
          return { color: params?.data?.isNew ? 'red' : '#303f6f' };
        },
        sortable: false,
        filter: false,
        minWidth: 286,
        // maxWidth: 316
      },
      {
        headerName: `${this.translate.data["MEMBERCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        // cellRendererParams: {
        //   onclick: (rowData: any) => this.handleRowClick(rowData)
        // },
        minWidth: 137,
        // maxWidth: 168
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
}